import React from "react";

import { Button } from "@mui/material";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Receipt } from "../../../../../../../domain/models/receipt-model";
import { StoreItem } from "../../../../../../../domain/models/storage-item";
import { CheckReceipt } from "../../../../../../../domain/usecases/check-receipt";
import { Total } from "../../../../Components/Total";
import CircularProgress from "@mui/material/CircularProgress";

type Props = {
  currentReceipt: Receipt;
  list: StoreItem[];
  checkReceipt: CheckReceipt;
  onFinish: () => void;
  isLoading?: boolean;
};

export const List: React.FC<Props> = ({
  list,
  onFinish,
  isLoading = false,
}) => {
  async function check() {
    await onFinish();
  }

  return (
    <>
      <Total text="Total de Itens Conferidos" number={`${list.length}`} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {list.map((item, index) => {
          return (
            <Paper sx={{ padding: "20px" }} key={index}>
              <Stack spacing={2}>
                <Typography fontWeight="bold" fontSize="24px">
                  {item.description}
                </Typography>
                <Typography>{`Fornecedor: ${item.supplier}`}</Typography>
                {item.batchControl ? (
                  <Typography>{`Lote: ${item.batch}`}</Typography>
                ) : (
                  ""
                )}
                <Typography>{`Quantidade: ${item.amount} (${(
                  item.amount * (item.packageAmount || 1)
                ).toFixed(2)} ${item?.unit})`}</Typography>
              </Stack>
            </Paper>
          );
        })}

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={check}
        >
          {isLoading ? <CircularProgress /> : "Finalizar Conferência"}
        </Button>
      </Stack>
    </>
  );
};
